import {Box, capitalize, Divider, MenuItem, Stack, Typography} from "@mui/material";
import {Field} from "formik";
import {Select, TextField} from "formik-mui";
import useMitarbeiter from "../../hooks/useMitarbeiter";

export default function BenutzerFieldsContent() {

    const { mitarbeiterTypen, translation } = useMitarbeiter();
    return (
        <Stack direction="column">
            <Box
                display={"grid"}
                sx={{gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"], gap: 2}}
            >
                <Field
                    component={TextField}
                    label="PersonalNr."
                    name="personalNummer"
                />
                <Field component={TextField} label="Anrede" name="anrede"/>
            </Box>
            <Box
                display={"grid"}
                sx={{
                    gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"],
                    gap: 2,
                    marginTop: 2,
                }}
            >
                <Field component={TextField} label="Nachname *" name="name"/>
                <Field component={TextField} label="Vorname" name="vorname"/>
                <Field
                    name="mitarbeiterTyp"
                    component={Select}
                    label={capitalize(translation("employee-type")) + " *"}
                    required
                >
                    {mitarbeiterTypen.map((typ) => (
                        <MenuItem key={typ} value={typ}>
                            {capitalize(typ.toLowerCase())}
                        </MenuItem>
                    ))}
                </Field>
            </Box>
            <Typography sx={{paddingTop: 2}}>{translation("address")}</Typography>
            <Divider sx={{marginBottom: 2}}/>
            <Box
                display={"grid"}
                sx={{gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"], gap: 2}}
            >
                <Field component={TextField} label={translation("street")} name="strasse"/>
            </Box>
            <Box
                display={"grid"}
                sx={{
                    gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"],
                    gap: 2,
                    marginTop: 2,
                }}
            >
                <Field component={TextField} label={translation("plz")} name="plz"/>
                <Field component={TextField} label={translation("city")} name="ort"/>
            </Box>
            <Typography sx={{paddingTop: 2}}>{translation("communication")}</Typography>
            <Divider sx={{marginBottom: 2}}/>
            <Box
                display={"grid"}
                sx={{gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"], gap: 2}}
            >
                <Field component={TextField} label={translation("phone")} name="telefon"/>
                <Field component={TextField} label={translation("email") + " *"} name="email"/>
            </Box>
            <Typography sx={{paddingTop: 2}}>Daten</Typography>
            <Divider sx={{marginBottom: 2}}/>
            <Box
                display={"grid"}
                sx={{gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"], gap: 2}}
            >
                <Field
                    component={TextField}
                    label={"Geburtsdatum"}
                    name="geburtsDatum"
                    type="date"
                    InputLabelProps={{shrink: true}}
                />
                <Field
                    component={TextField}
                    label={"Wochenarbeitszeit"}
                    name="wochenArbeitszeit"
                    inputProps={{style: {textAlign: "right"}}}
                />
                <Field
                    component={TextField}
                    label={"Pauschalverguetung in EUR"}
                    name="pauschalVerguetung"
                    inputProps={{style: {textAlign: "right"}}}
                />
            </Box>
            <Box
                display={"grid"}
                sx={{
                    gridTemplateColumns: ["1fr", "1fr 1fr 1fr 1fr"],
                    gap: 2,
                    marginTop: 2,
                }}
            >
                <Field
                    component={TextField}
                    label={"Eintrittsdatum"}
                    name="eintrittsDatum"
                    type="date"
                    InputLabelProps={{shrink: true}}
                />
                <Field
                    component={TextField}
                    label={"Berechnungssatz in EUR"}
                    name="berechnungsSatz"
                    inputProps={{style: {textAlign: "right"}}}
                />
                <Field
                    component={TextField}
                    label={"Stundenlohn in EUR"}
                    name="stundenLohn"
                    inputProps={{style: {textAlign: "right"}}}
                />
            </Box>
        </Stack>
    );
}
